import { IoCloseSharp } from "react-icons/io5";
import Button from "../../../components/Button/button";
import {
  BlueTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../../shared/styles/global.styles";
import React, { useState } from "react";
import {
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  TableContainer,
} from "../../../components/Table/styles";
import Pagination from "../../../components/Pagination/pagination";
import Swal from "sweetalert2";
import {
  ResponseSearchFastContribuinte,
  ResponseSearchFastDependente,
} from "../../../shared/dtos/ReponseFastSearch.dto";

interface Props {
  show: boolean;
  onClose: () => void;
  dependenteData?: ResponseSearchFastDependente[];
  contribuinteData?: ResponseSearchFastContribuinte[];
  setContribuinteData: React.Dispatch<
    React.SetStateAction<ResponseSearchFastContribuinte | undefined>
  >;
  setDependenteData: React.Dispatch<
    React.SetStateAction<ResponseSearchFastDependente | undefined>
  >;
}

const ModalSelectData: React.FC<Props> = ({
  show,
  onClose,
  dependenteData,
  contribuinteData,
  setContribuinteData,
  setDependenteData,
}) => {
  const totalItens = 5;
  const allDataSelect: any = [
    ...(contribuinteData || []),
    ...(dependenteData || []),
  ];
  const totalPages = Math.ceil(allDataSelect?.length / totalItens || 0);
  const [currentPage, setCurrentPage] = useState(1);

  const handleSelectContribuinte = (
    contribuinte: ResponseSearchFastContribuinte
  ) => {
    setContribuinteData(contribuinte);
    // Swal.fire({
    //   icon: "success",
    //   title: "Sucesso",
    //   text: "Dados carregados com sucesso!",
    //   showConfirmButton: true,
    //   confirmButtonText: "OK",
    // });
    onClose();
  };
  const handleSelectDependente = (dependente: ResponseSearchFastDependente) => {
    setDependenteData(dependente);
    setContribuinteData(dependente.contribuinte);
    // Swal.fire({
    //   icon: "success",
    //   title: "Sucesso",
    //   text: "Dados carregados com sucesso!",
    //   showConfirmButton: true,
    //   confirmButtonText: "OK",
    // });
    onClose();
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return (
    <ModalContainer show={show}>
      <ModalContent width={50}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>
            Selecione o{" "}
            {contribuinteData &&
            contribuinteData.length > 0 &&
            dependenteData &&
            dependenteData.length > 0
              ? "titular/dependente"
              : contribuinteData
              ? "titular"
              : "dependente"}{" "}
            que deseja carregar os dados
          </BlueTitle>
        </ModalHeader>
        <ModalBody>
          <>
            {allDataSelect && allDataSelect?.length > 0 && (
              <>
                <TableContainer style={{ flex: 1 }}>
                  <Table id="contribuinte-modal-table">
                    <TableHead>
                      <TableRow>
                        <TableHeader>Tipo contribuinte</TableHeader>
                        <TableHeader>Nome</TableHeader>
                        <TableHeader>CPF</TableHeader>
                        <TableHeader>Ação</TableHeader>
                      </TableRow>
                    </TableHead>
                    <tbody>
                      {allDataSelect
                        .slice(
                          (currentPage - 1) * totalItens,
                          currentPage * totalItens
                        )
                        .map((data: any) => (
                          <>
                            <TableRow key={`Dados-contribuinte`}>
                              <TableData>
                                {data.contribuinte ? "Dependente" : "Titular"}
                              </TableData>
                              <TableData>{data.nome}</TableData>
                              <TableData>{data.cpfCin}</TableData>
                              <TableData>
                                <Button
                                  type="button"
                                  action={() => {
                                    if (data.contribuinte) {
                                      handleSelectDependente(
                                        data as ResponseSearchFastDependente
                                      );
                                    } else {
                                      handleSelectContribuinte(
                                        data as ResponseSearchFastContribuinte
                                      );
                                    }
                                  }}
                                  schemaButton="full-primary"
                                >
                                  Selecionar
                                </Button>
                              </TableData>
                            </TableRow>
                          </>
                        ))}
                    </tbody>
                  </Table>
                </TableContainer>
              </>
            )}
          </>
        </ModalBody>
        {totalPages > 1 && (
          <ModalFooter>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </ModalFooter>
        )}
      </ModalContent>
    </ModalContainer>
  );
};

export default ModalSelectData;
